import { render, staticRenderFns } from "./FormFeatured.vue?vue&type=template&id=2b1f7b02&"
import script from "./FormFeatured.vue?vue&type=script&lang=js&"
export * from "./FormFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports